import apiRequest from '@/utils/apiRequest';
import { IGetRolesResponse } from '@/stores/role/type';

const endpoint = '/roles';

export const getRolesApi = (): Promise<IGetRolesResponse> => {
  return apiRequest.get(endpoint);
};
